<template>
  <div class="chip">
    <div class="chip__content">
      <span
        class="chip__text text-label-xs"
        v-text="text"
      />
      <icon-close @click="$emit('remove')" />
    </div>
  </div>
</template>

<script>
import IconClose from '~icons/misc/close.svg'

/**
 * Vue: chip (chip)
 * -----------------------------------------------------------------------------
 * Chips that display a text with remove icon.
 *
 */
export default {
  name: 'Chip',

  components: {
    IconClose,
  },

  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
  },

  emits: ['remove'],
}
</script>

<style lang="scss">
@import './chip';
</style>
